import React, { useEffect, useState } from 'react';
import styles from 'routes/vendorRe/pages/VendorSale.module.css';
import Container from 'routes/vendorRe/containers/commons/Container';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import P from 'routes/vendorRe/containers/commons/P';
import {
    commonBgColor,
    contentStart,
    commonH1Padding,
    commonH1Size,
    infoBorderColor,
    infoFontSize1,
    commonBodyPadding,
} from 'routes/vendorRe/constraint/constraints';
import VendorSaleList from 'routes/vendorRe/components/VendorSaleList';
import { requester } from 'App';
import { combineDuplicates, filterDataByThisWeek } from 'routes/vendorRe/commonFn/vendorPurchaseOrder';
import { useLocation, useParams } from 'react-router-dom';
import Dummy from 'components/Dummy';

const VendorSale = (props) => {
    const { storeId } = useParams();
    const location = useLocation();
    const [isMounted, setMounted] = useState(false);
    const [saleData, setSaleData] = useState();
    const [storeName, setStoreName] = useState();

    useEffect(() => {
        setMounted(true);
    }, []);
    useEffect(() => {
        if (storeId) {

        }
    }, [storeId])
    useEffect(() => {
        if (location.state) {

            setStoreName(location.state.storeName);

        }
    }, [location])


    useEffect(() => {
        if (isMounted) {
            if (storeId) {
                let data = { id: storeId }
                requester.findAllOrderProductsByStoreId(data, (result) => {

                    // 오늘 자 기준, [월~일] 주간의 데이터 가져오기
                    const filteredData = filterDataByThisWeek(result.data);


                    // 여러 주문 중에 중복되는 아이템 합치기
                    const combinedSaleData = combineDuplicates(filteredData);


                    setSaleData(combinedSaleData); // 판매 데이터 설정
                })
            } else {
                requester.findAllVendorPurchaseOrder((result) => {

                    // 오늘 자 기준, [월~일] 주간의 데이터 가져오기
                    const filteredData = filterDataByThisWeek(result.data);
                    // 여러 주문 중에 중복되는 아이템 합치기
                    const combinedSaleData = combineDuplicates(filteredData);
                    setSaleData(combinedSaleData); // 판매 데이터 설정
                })
            }

        }
    }, [isMounted]);

    return (
        <Container backgroundColor={commonBgColor} height={"90vh"}>
            <div style={{ height: "10vh" }}></div>
            <VerticalFlex backgroundColor={commonBgColor}>
                <FlexChild padding={commonBodyPadding} alignItems={contentStart}>
                    <P padding={commonH1Padding} size={commonH1Size}>{storeName ? storeName : "전 매장"} 판매 내역 조회</P>
                    <VerticalFlex backgroundColor="#fff" borderRadius="1em" padding="1.5em">
                        <FlexChild>
                            <div style={{ fontSize: infoFontSize1, padding: "0 0 24px", borderBottom: infoBorderColor }}>판매량 BEST</div>
                            <div className={styles.scrollCover}>
                                <VerticalFlex height="auto">
                                    {/* 반복 구간 시작*/}
                                    {
                                        saleData && saleData.length > 0 ?
                                            saleData.sort((a, b) => b.quantity - a.quantity).map((saleItem, index) => (
                                                <VendorSaleList key={index} data={saleItem} />
                                            ))
                                            :
                                            <FlexChild>
                                                <Dummy height={"30px"} />
                                                <P size={"2.8vw"}>데이터가 없습니다</P>
                                            </FlexChild>
                                    }
                                    {/* 반복 구간 끝 */}
                                </VerticalFlex>
                            </div>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default VendorSale;